export default "__VITE_ASSET__COUnCVLu__"